// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { render, createElement, LocaleProvider } from '@plesk/ui-library';
import Promo from './Promo';

const onCloseItem = ({ hideUrl }) => {
    new Ajax.Request(hideUrl, { method: 'post' });
};

module.exports = ({ container, locale, ...props }) => {
    render((
        <LocaleProvider messages={locale}>
            <Promo {...props} onCloseItem={onCloseItem} />
        </LocaleProvider>
    ), container);
};



// WEBPACK FOOTER //
// ./app/promo/index.js